import Util from '../../shared/util/util';
import {MODAL_TYPE, showModal} from '../../shared/components/modals/generic_modal_conductor';
import ShortcutModalContent from '../../shared/components/modals/navigation/ShortcutsModal';
import React, {useEffect} from 'react';
import {useHistory} from 'react-router-dom';
import {useIntl} from 'react-intl';
import {getConnectProjectIDFromPath, getProjectIdFromPath} from '../../shared/util/UrlContextUtil';
import {trackEvent} from '../../../tracking/amplitude/TrackingV2';
import {projectGroupUrl, projectUrl} from '../../../directApi';

const KeyboardShortcuts = () => {
	const history = useHistory();
	const {formatMessage} = useIntl();
	const inEditMode = () =>
		(document.activeElement && document.activeElement.nodeName === 'INPUT') ||
		(document.activeElement &&
			document.activeElement.className &&
			document.activeElement.className.includes('DraftEditor'));

	const handleEventTracking = value => {
		trackEvent('Shortcut', 'Pressed', {value});
	};
	const handleShortcutProject = event => {
		const currentPath = history.location.pathname;

		if (event.altKey && event.shiftKey && !inEditMode()) {
			const projectID = getProjectIdFromPath(currentPath);
			const projectGroupID = getConnectProjectIDFromPath(currentPath);
			if (!projectID && !projectGroupID) {
				return;
			}
			const navLinkBase = projectID ? projectUrl(projectID) : projectGroupUrl(projectGroupID);

			switch (event.keyCode) {
				case 48: // 0
					if (!Util.AuthorizeViewerAccess('project-files') || projectGroupID) return;
					handleEventTracking('project-files');
					history.push(navLinkBase + '/files');
					break;

				case 49: // 1
					if (!Util.AuthorizeViewerAccess('project-initial-plan') || projectGroupID) return;
					handleEventTracking('project-baseline');
					history.push(navLinkBase + '/initial-plan'); //Baseline
					break;

				case 50: // 2
					if (!Util.AuthorizeViewerAccess('project-phases') || projectGroupID) return;
					handleEventTracking('project-scoping');
					history.push(navLinkBase + '/scoping');
					break;

				case 51: // 3
					handleEventTracking('project-task-board');
					history.push(navLinkBase + '/workflow');
					break;

				case 52: // 4
					handleEventTracking('project-sprints');
					history.push(navLinkBase + '/sprints');
					break;

				case 53: // 5
					if (!Util.AuthorizeViewerAccess('project-periods') || projectGroupID) return;
					handleEventTracking('project-retainer-tracking');
					history.push(navLinkBase + '/retainer-tracking'); //Retainer
					break;

				case 54: // 6
					if (!Util.AuthorizeViewerAccess('project-timeline') || projectGroupID) return;
					handleEventTracking('project-timeline');
					history.push(navLinkBase + '/schedule'); //Timeline
					break;

				case 55: // 7
					if (!Util.AuthorizeViewerAccess('project-budget') || projectGroupID) return;
					handleEventTracking('project-financials');
					history.push(navLinkBase + '/budget'); //Financials
					break;

				case 56: // 8
					if (!Util.AuthorizeViewerAccess('project-health') || projectGroupID) return;
					handleEventTracking('project-nova-insights');
					history.push(navLinkBase + '/nova-insights'); //Financials
					break;

				case 57: // 9
					if (!Util.AuthorizeViewerAccess('project-client') || projectGroupID) return;
					handleEventTracking('project-client');
					history.push(navLinkBase + '/client');
					break;

				case 187: // +
					if (!Util.AuthorizeViewerAccess('project-settings')) return;
					handleEventTracking('project-settings');
					if (projectGroupID) {
						history.push(navLinkBase + '/group-settings');
					} else {
						history.push(navLinkBase + '/settings');
					}
					break;

				case 219: // ´
					if (!Util.AuthorizeViewerAccess('connected-projects') || projectID) return;
					handleEventTracking('connected-projects-list');
					history.push(navLinkBase + '/connected-projects');
					break;

				default:
					break;
			}
		}
	};

	const handleShortcutApp = event => {
		if (event.shiftKey && !inEditMode()) {
			if (event.altKey) {
				switch (event.keyCode) {
					case 87: // W
						handleEventTracking('my-tasks');
						history.push('/');
						break;
					case 80: // P
						handleEventTracking('all-projects');
						history.push('/projects');
						break;
					case 82: // R
						handleEventTracking('timesheets');
						history.push('/time');
						break;
					case 84: // T
						handleEventTracking('all-timelines');
						history.push('/scheduling');
						break;
					case 89: // Y
						handleEventTracking('all-reports');
						history.push('/insights');
						break;
					case 81: // Q
						handleEventTracking('show-shortcuts');
						showModal({
							type: MODAL_TYPE.GENERIC,
							headerText: formatMessage({id: 'header.shortcuts'}),
							content: <ShortcutModalContent />,
						});
						break;
					default:
						break;
				}
			}
		} else if (event.ctrlKey && !inEditMode()) {
			if (event.altKey) {
				switch (event.keyCode) {
					case 84: // T
						handleEventTracking('create-task');
						//New task shortcut
						showModal({
							type: MODAL_TYPE.NEW_TASK,
							isOpenedByShortcut: true,
						});
						break;
					case 80: // P
						handleEventTracking('create-project');
						//New Project shortcut
						showModal({
							type: MODAL_TYPE.NEW_PROJECT_V2,
						});
						break;
					case 69: // E
						handleEventTracking('create-expense');
						//New Expense shortcut
						showModal({
							type: MODAL_TYPE.EXPENSE_ITEM,
						});
						break;
					default:
						break;
				}
			}
		}
	};

	useEffect(() => {
		document.addEventListener('keydown', handleShortcutProject);
		document.addEventListener('keydown', handleShortcutApp);

		return () => {
			document.removeEventListener('keydown', handleShortcutProject);
			document.removeEventListener('keydown', handleShortcutApp);
		};
	}, []);

	return <></>;
};

export default KeyboardShortcuts;
